
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyCwBy2eJXdXiTb-xRwqAPGGacqv01bvvy4",
  authDomain: "jowzeyugaly.firebaseapp.com",
  databaseURL: "https://jowzeyugaly-default-rtdb.firebaseio.com",
  projectId: "jowzeyugaly",
  storageBucket: "jowzeyugaly.appspot.com",
  messagingSenderId: "1007373319974",
  appId: "1:1007373319974:web:8d408426292e50a2380be7",
  measurementId: "G-DKSYHMHWDE"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export default app;


